import { render, staticRenderFns } from "./HeroComponent.vue?vue&type=template&id=c2ff688e&"
import script from "./HeroComponent.vue?vue&type=script&lang=js&"
export * from "./HeroComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports